import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { Icon as IconSvelte } from '@glance-networks/ui-core-components';

export const Icon = (props) => {
  const defineProps = {
    size: props.size,
    name: props.name,
    weight: props.weight,
    title: props.title,
    color: props.color,
    class: props.className ?? props.class,
    style: props.style,
    'aria-hidden': props['aria-hidden'],
    'aria-label': props['aria-label'],
  };
  return (
    <Svelte component={IconSvelte} {...defineProps} />
  );
};
